import { handleRequest } from "../utilities/requestHandler";

export const forgotPassword = (req_body) =>
    handleRequest("post", "/users/forgotpassword",req_body);